import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import NotificationCenter from "./NotificationCenter";
import "./Navbar.css";

function Dropdown({ label, items, onClose }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const location = useLocation();

  useEffect(() => {
    if (!open) return;
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, [open]);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isActive = items.some(([to]) => location.pathname.startsWith(to));

  return (
    <div className="nav-dropdown" ref={ref}>
      <button
        className={`nav-link nav-dropdown-trigger${isActive ? " active" : ""}${open ? " open" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {label}
        <span className="nav-dropdown-arrow">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="nav-dropdown-panel">
          {items.map(([to, itemLabel, icon]) => (
            <NavLink key={to} to={to}
              className={({ isActive }) => `nav-dropdown-item${isActive ? " active" : ""}`}
              onClick={() => { setOpen(false); onClose(); }}
            >
              {icon && <span className="nav-dropdown-icon">{icon}</span>}
              {itemLabel}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

const ADMIN_EMAILS = ["nayth@takkyuoni.com","aino@takkyuoni.com"];

export default function Navbar() {
  const { user, isAdmin, profile } = useAuth();
  const adminByEmail = user && ADMIN_EMAILS.includes(user.email);
  const showAdmin    = isAdmin || adminByEmail;
  const hasDemon     = !!(profile?.demon);
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const close = () => setOpen(false);

  const PUBLIC_LINKS = [
    ...(!hasDemon ? [["/awaken", "RÉVEIL"]] : []),
    ["/lore",    "LÉGENDE"],
    ["/merch",   "BOUTIQUE"],
  ];

  const ONI_MENU = [
    ["/profile",  "Mon Profil",  "👹"],
    ["/journal",  "OniTalk",     "💬"],
    ["/coach",    "Coach",       "🎥"],
    ["/fftt",     "Proies",      "🎯"],
  ];

  const COMBAT_MENU = [
    ["/duel",    "Duel",        "⚔️"],
    ["/team",    "Combat de Clans", "🔴"],
    ["/ranking", "Classement",  "🏆"],
  ];

  const SOCIAL_MENU = [
    ["/social", "Social", "🤝"],
  ];

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      <Link to="/" className="nav-logo" onClick={close}>
        <span className="oni-glyph">鬼</span>
        <span className="brand-text">TAKKYU ONI</span>
      </Link>

      <div className="navbar-right">
        {user && <NotificationCenter />}
        <button className="burger" onClick={() => setOpen(!open)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>

      <div className={`nav-links${open ? " open" : ""}`}>
        {PUBLIC_LINKS.map(([to, label]) => (
          <NavLink key={to} to={to}
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            onClick={close}>
            {label}
          </NavLink>
        ))}

        {user && (
          <>
            <Dropdown label="MON ONI"  items={ONI_MENU}    onClose={close} />
            <Dropdown label="COMBAT"   items={COMBAT_MENU} onClose={close} />
            <Dropdown label="SOCIAL"   items={SOCIAL_MENU} onClose={close} />
            {showAdmin && (
              <NavLink to="/admin"
                className={({ isActive }) => `nav-link nav-admin${isActive ? " active" : ""}`}
                onClick={close}>
                ADMIN
              </NavLink>
            )}
          </>
        )}

        {!user && (
          <Link to="/auth" className="btn btn-primary btn-sm" onClick={close}>ENTRER</Link>
        )}

        <NavLink to="/about"
          className={({ isActive }) => `nav-link nav-link-end${isActive ? " active" : ""}`}
          onClick={close}>
          FONDATEURS
        </NavLink>
      </div>
    </nav>
  );
}
